/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Type_OtherInputs */

const cs_public_site_demand_type_other = /** @type {(inputs: Public_Site_Demand_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jiné`)
};

const en_public_site_demand_type_other = /** @type {(inputs: Public_Site_Demand_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Public_Site_Demand_Type_OtherInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_type_other = /** @type {((inputs?: Public_Site_Demand_Type_OtherInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Type_OtherInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_type_other(inputs)
	return cs_public_site_demand_type_other(inputs)
});